export default [

  {
    path: '*',
    meta: {
      public: true,
    },
    redirect: {
      path: '/404'
    }
  },
  {
    path: '/404',
    meta: {
      public: true,
    },
    name: 'NotFound',
    component: () => import(
      `@/pages/NotFound.vue`
    )
  },
  {
    path: '/403',
    meta: {
      public: true,
    },
    name: 'AccessDenied',
    component: () => import(
      `@/pages/Deny.vue`
    )
  },
  {
    path: '/500',
    meta: {
      public: true,
    },
    name: 'ServerError',
    component: () => import(
      `@/pages/Error.vue`
    )
  },
  {
    path: '/login',
    meta: {
      public: true,
    },
    name: 'Login',
    component: () => import(
      `@/pages/Login.vue`
    )
  },
  {
    path: '/',
    redirect: '/dashboard',
    component: () => import(`@/themes/MainTheme.vue`),

    meta: { requiresAuth: true },
    children: [
      {
        path: '',
        meta: { breadcrumb: true, requiresAuth: true },
        name: 'Root',
        redirect: {
          name: 'dashboard'
        }
      },
      {
        path: 'dashboard',
        meta: { breadcrumb: true, requiresAuth: true },
        name: 'dashboard',
        component: () => import(
          `@/pages/Dashboard.vue`
        )
      },
      {
        path: '/initial-document',
        meta: { breadcrumb: true , requiresAuth: true},
        name: 'InitialDoc',
        component: () => import(
          `@/pages/pack/InitialDoc.vue`
        )
      }, 
      {
        path: 'shipmentpacktrack',
        meta: { breadcrumb: true, requiresAuth: true },
        name: 'shipmentpacktrack',
        component: () => import(
          `@/pages/ShipmentPackTrack.vue`
        )
      }, 
      {
        path: '/shipparcel',
        meta: { breadcrumb: true, requiresAuth: true },
        name: 'shipparcel',
        component: () => import(
          `@/pages/ShipParcel.vue`
        )
      }, 
      {
        path: '/dropparcel',
        meta: { breadcrumb: true, requiresAuth: true },
        name: 'dropparcel',
        component: () => import(
          `@/pages/DropParcel.vue`
        )
      }, 
      {
        path: '/dropparcelsubmit/:roworderlist',
        meta: { breadcrumb: true, requiresAuth: true },
        name: 'dropparcelsubmit',
        component: () => import(
          `@/pages/DropParcelSubmit.vue`
        )
      }, 
      {
        path: '/moveparcel',
        meta: { breadcrumb: true, requiresAuth: true },
        name: 'moveparcel',
        component: () => import(
          `@/pages/MoveParcel.vue`
        )
      },
      {
        path: '/shipmentpack',
        meta: { breadcrumb: true, requiresAuth: true },
        name: 'shipmentpack',
        component: () => import(
          `@/pages/ShipmentPack.vue`
        )
      },
      {
        path: '/dropimageconfirm',
        meta: { breadcrumb: true, requiresAuth: true },
        name: 'dropimageconfirm',
        component: () => import(
          `@/pages/DropImageConfirm.vue`
        )
      }
    ]
  }
];
